import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSnackbar } from '#hooks';
import services from '#services';
import { actions } from '#store';

const usePois = () => {
  const { enqueueErrorSnackbar } = useSnackbar();
  const state = useSelector(prop('pois'));
  const dispatch = useDispatch();

  const fetch = useCallback(async (query, { enableSnackbar } = {}) => {
    try {
      dispatch(actions.pois.fetch.creator());
      const pois = await services.bob.pois.getAll(query);
      dispatch(actions.pois.fetchSuccess.creator({ payload: pois }));
      return pois;
    } catch (err) {
      dispatch(actions.pois.fetchError.creator({ error: err.message }));
      if (enableSnackbar) {
        enqueueErrorSnackbar(err.message, {
          persist: true,
          buttons: [{
            text   : 'retry',
            onClick: () => fetch(query, { enableSnackbar }),
          }],
        });
        return null;
      }
      throw err;
    }
  }, [dispatch]);

  return {
    ...state,
    handlers: {
      fetch,
    },
  };
};

export default usePois;
